/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ quarter: NonNullable<unknown>, clock: NonNullable<unknown>, court: NonNullable<unknown>, event: NonNullable<unknown> }} Live_Now_AtInputs */

const th_live_now_at = /** @type {(inputs: Live_Now_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`กำลังแข่ง · ${i?.quarter} ${i?.clock} · ${i?.court} · ${i?.event}`)
};

const en_live_now_at = /** @type {(inputs: Live_Now_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Live · ${i?.quarter} ${i?.clock} · ${i?.court} · ${i?.event}`)
};

const ja_live_now_at = /** @type {(inputs: Live_Now_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`試合中 · ${i?.quarter} ${i?.clock} · ${i?.court} · ${i?.event}`)
};

const zh_live_now_at = /** @type {(inputs: Live_Now_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`直播中 · ${i?.quarter} ${i?.clock} · ${i?.court} · ${i?.event}`)
};

const es_live_now_at = /** @type {(inputs: Live_Now_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`En directo · ${i?.quarter} ${i?.clock} · ${i?.court} · ${i?.event}`)
};

const pt_live_now_at = /** @type {(inputs: Live_Now_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ao vivo · ${i?.quarter} ${i?.clock} · ${i?.court} · ${i?.event}`)
};

const id_live_now_at = /** @type {(inputs: Live_Now_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Langsung · ${i?.quarter} ${i?.clock} · ${i?.court} · ${i?.event}`)
};

const fr_live_now_at = /** @type {(inputs: Live_Now_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`En direct · ${i?.quarter} ${i?.clock} · ${i?.court} · ${i?.event}`)
};

const tl_live_now_at = /** @type {(inputs: Live_Now_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Live · ${i?.quarter} ${i?.clock} · ${i?.court} · ${i?.event}`)
};

const vi_live_now_at = /** @type {(inputs: Live_Now_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trực tiếp · ${i?.quarter} ${i?.clock} · ${i?.court} · ${i?.event}`)
};

const ko_live_now_at = /** @type {(inputs: Live_Now_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`실시간 · ${i?.quarter} ${i?.clock} · ${i?.court} · ${i?.event}`)
};

const de_live_now_at = /** @type {(inputs: Live_Now_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Live · ${i?.quarter} ${i?.clock} · ${i?.court} · ${i?.event}`)
};

const ru_live_now_at = /** @type {(inputs: Live_Now_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Прямой эфир · ${i?.quarter} ${i?.clock} · ${i?.court} · ${i?.event}`)
};

const tr_live_now_at = /** @type {(inputs: Live_Now_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Canlı · ${i?.quarter} ${i?.clock} · ${i?.court} · ${i?.event}`)
};

const it_live_now_at = /** @type {(inputs: Live_Now_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`In diretta · ${i?.quarter} ${i?.clock} · ${i?.court} · ${i?.event}`)
};

const pl_live_now_at = /** @type {(inputs: Live_Now_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Na żywo · ${i?.quarter} ${i?.clock} · ${i?.court} · ${i?.event}`)
};

const uk_live_now_at = /** @type {(inputs: Live_Now_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`У прямому ефірі · ${i?.quarter} ${i?.clock} · ${i?.court} · ${i?.event}`)
};

const hi_live_now_at = /** @type {(inputs: Live_Now_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`लाइव · ${i?.quarter} ${i?.clock} · ${i?.court} · ${i?.event}`)
};

const ar_live_now_at = /** @type {(inputs: Live_Now_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`مباشر · ${i?.quarter} ${i?.clock} · ${i?.court} · ${i?.event}`)
};

const ms_live_now_at = /** @type {(inputs: Live_Now_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Langsung · ${i?.quarter} ${i?.clock} · ${i?.court} · ${i?.event}`)
};

const bn_live_now_at = /** @type {(inputs: Live_Now_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`সরাসরি · ${i?.quarter} ${i?.clock} · ${i?.court} · ${i?.event}`)
};

const zh_tw2_live_now_at = /** @type {(inputs: Live_Now_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`直播中 · ${i?.quarter} ${i?.clock} · ${i?.court} · ${i?.event}`)
};

const zh_hk2_live_now_at = /** @type {(inputs: Live_Now_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`直播中 · ${i?.quarter} ${i?.clock} · ${i?.court} · ${i?.event}`)
};

const ur_live_now_at = /** @type {(inputs: Live_Now_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`براہ راست · ${i?.quarter} ${i?.clock} · ${i?.court} · ${i?.event}`)
};

const fa_live_now_at = /** @type {(inputs: Live_Now_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`زنده · ${i?.quarter} ${i?.clock} · ${i?.court} · ${i?.event}`)
};

const sw_live_now_at = /** @type {(inputs: Live_Now_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Moja kwa moja · ${i?.quarter} ${i?.clock} · ${i?.court} · ${i?.event}`)
};

const nl_live_now_at = /** @type {(inputs: Live_Now_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Live · ${i?.quarter} ${i?.clock} · ${i?.court} · ${i?.event}`)
};

/**
* | output |
* | --- |
* | "Live · {quarter} {clock} · {court} · {event}" |
*
* @param {Live_Now_AtInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const live_now_at = /** @type {((inputs: Live_Now_AtInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Now_AtInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_live_now_at(inputs)
	if (locale === "ja") return ja_live_now_at(inputs)
	if (locale === "zh") return zh_live_now_at(inputs)
	if (locale === "es") return es_live_now_at(inputs)
	if (locale === "pt") return pt_live_now_at(inputs)
	if (locale === "id") return id_live_now_at(inputs)
	if (locale === "fr") return fr_live_now_at(inputs)
	if (locale === "tl") return tl_live_now_at(inputs)
	if (locale === "vi") return vi_live_now_at(inputs)
	if (locale === "ko") return ko_live_now_at(inputs)
	if (locale === "de") return de_live_now_at(inputs)
	if (locale === "ru") return ru_live_now_at(inputs)
	if (locale === "tr") return tr_live_now_at(inputs)
	if (locale === "it") return it_live_now_at(inputs)
	if (locale === "pl") return pl_live_now_at(inputs)
	if (locale === "uk") return uk_live_now_at(inputs)
	if (locale === "hi") return hi_live_now_at(inputs)
	if (locale === "ar") return ar_live_now_at(inputs)
	if (locale === "ms") return ms_live_now_at(inputs)
	if (locale === "bn") return bn_live_now_at(inputs)
	if (locale === "zh-TW") return zh_tw2_live_now_at(inputs)
	if (locale === "zh-HK") return zh_hk2_live_now_at(inputs)
	if (locale === "ur") return ur_live_now_at(inputs)
	if (locale === "fa") return fa_live_now_at(inputs)
	if (locale === "sw") return sw_live_now_at(inputs)
	if (locale === "nl") return nl_live_now_at(inputs)
	return en_live_now_at(inputs)
});